import { Problem } from './Problem';

export function formatProblem(problem: Problem): string {
    return `${problem.title || 'Request Failed'}: ${problem.detail || 'Unspecified Error'}`;
}
